import { render, staticRenderFns } from "./ForexCurrencyPairDeleteModal.vue?vue&type=template&id=66a872cb"
import script from "./ForexCurrencyPairDeleteModal.vue?vue&type=script&lang=js"
export * from "./ForexCurrencyPairDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports